import axios from '@/libs/api.request'

export const getParameterMergeList = (params) => {
  return axios.request({
    url: '/v1/cmdb/parameter_merge/',
    method: 'get',
    params
  })
}

export const saveParameterMerge = (data) => {
  return axios.request({
    url: '/v1/cmdb/parameter_merge/',
    method: 'post',
    data
  })
}

export const deleteParameterMerge = (id) => {
  return axios.request({
    url: '/v1/cmdb/parameter_merge/',
    method: 'delete',
    data: { id }
  })
}

export const iterateParameterMerge = (data) => {
  return axios.request({
    url: '/v1/cmdb/parameter_merge/iterate/',
    method: 'post',
    data
  })
}